<template>
  <div class="content-wrap">
    <template v-if="!showDetail">
      <div class="info-box-wrap">
        <div class="info-box count-box">
          <div class="info-box-title">可索取发票金额</div>
          <b>￥ {{totalAmount || 0}}</b>
          <div class="info-btn" @click="openRequestInvoice">申请发票</div>
        </div>
        <div class="info-box invoice-box">
          <div class="info-box-title">发票信息</div>
          <div class="info-desc">默认抬头: {{form.buyerName.value  }}</div>
          <div class="info-desc">纳税识别号: {{form.dutyParagraph.value  }}</div>
          <div class="info-btn" @click="openInvoiceTitle">配置开票信息</div>
        </div>
      </div>
      <div class="search-table">
        <div class="content-header">
          <b>已开发票</b>
          <div class="search-box">
            <input type="text" placeholder="请输入关键字" v-model="searchName" />
            <div class="search-btn" @click="searchData">搜索</div>
          </div>
        </div>
        <Table :columns="columns" :rows-data="rowsData">
          <template slot-scope="scope">
            <div v-if="scope.col.key === 'status'" class="table-op">
              审核中
            </div>
          </template>
        </Table>
        <Pagination
          :currentPage="currentPage"
          :total="total"
          @change="pageChange"
        />
      </div>
    </template>
    <template v-else>
      <div class="content-tips-box">
        <b>说明:</b>
        <p>1.可申请开票额为报名或会员年费所产生的费用。</p>
        <p>2.活动及培训过程发生的任何风险，浙江省风景园林学会及本网站运营方不承担任何民事责任，由发布者全全承担。</p>
        <p>3.禁止使用本网站张贴或发送任何属于或可能属于侵权、恐吓、欺诈、误导、煽动、损害他人名誉、侵犯隐私、淫秽、色情、辱骂、歧视和非法性质的权料，禁止使用本网站开展广告活动或实施任何商业招揽行为。</p>        
      </div>
      <div class="search-table">
        <div class="content-header">
          <b>支出列表</b>
          <div class="search-box">
            <div class="search-btn" @click="showDetail = !showDetail" style="margin-right: 10px;background: #f1f3f3;color: #06AE63;border: 1px solid #06AE63;">返回</div>
            <div class="search-btn" @click="openRequestInvoice">立即开票</div>
          </div>
        </div>
        <Table :columns="columns" :rows-data="rowsData" :rowSelection="rowSelection">
          <template slot-scope="scope">
            <div v-if="scope.col.key === 'status'" class="table-op">
              审核中
            </div>
          </template>
        </Table>
        <Pagination
          :currentPage="currentPage"
          :total="total"
          @change="pageChange"
        />
      </div>
    </template>
    <Modal :visible="configInvoiceVisible">
      <ConfigInvoice
        :form="form"
        @confirm="onConfigInvoiceConfirm"
        @cancel="onConfigInvoiceModalClose"
      />
    </Modal>
    <Modal :visible="requestInvoiceVisible">
      <RequestInvoiceModal
        :form="requestForm"
        @confirm="onRequestInvoiceConfirm"
        @cancel="onRequestInvoiceModalClose"
      />
    </Modal>
  </div>
</template>

<script>
import moment from "moment";
import Table from "@/components/Table";
import Modal from "@/components/Modal";
import Pagination from "@/components/Pagination";
import ConfigInvoice from "./components/ConfigInvoice";
import RequestInvoiceModal from "./components/RequestInvoiceModal";
import { configInvoiceBuyerInfo,getInvoiceBuyerInfo,getTodoPayRecordList,applyInvoice,getInvoiceApplyList } from "./service/api";


export default {
  data() {
    return {
      showDetail: false,
      totalAmount:0,
      searchName: '',
      rowsData: [],
      columns: [{
        key: "applyTimeStr",
        dataIndex: "applyTimeStr",
        name: "申请时间",
        maxWidth: "100px",
      },
      {
        key: "applyTitle",
        dataIndex: "applyTitle",
        name: "申请内容",
      },
      {
        key: "applyAmount",
        dataIndex: "applyAmount",
        name: "申请开票金额",
        maxWidth: "100px",
      },
      {
        key: "expressInfo",
        dataIndex: "expressInfo",
        name: "收件信息",
      },
      {
        key: "applyStateStr",
        dataIndex: "applyStateStr",
        name: "发票状态",
        maxWidth: "100px",
      },],
      currentPage: 1,
      pageSize: 10,
      total: 0,
      configInvoiceVisible: false,
      form: {
        // invoiceType: {
        //   require: true,
        //   error: false,
        //   value: '',
        //   fieldCode: 'invoiceType',
        //   fieldType: 'Select',
        //   fieldName: '开票类型',
        //   valueList: [
        //     {
        //       value:"专票",
        //       key:"2"
        //     },
        //     {
        //       value:"普票",
        //       key:"1"
        //     }            
        //   ],
        //   validate: v => {
        //     if (!v) {
        //       this.form.invoiceType.error = '开票类型必选';
        //       return false;
        //     }
        //     this.form.invoiceType.error = '';
        //     return true;
        //   }
        // },
        buyerName: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'buyerName',
          fieldName: '发票抬头',
          validate: v => {
            if (!v) {
              this.form.buyerName.error = '发票抬头必填';
              return false;
            }
            this.form.buyerName.error = '';
            return true;
          }
        },
        dutyParagraph: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'dutyParagraph',
          fieldName: '税务号',
          validate: v => {
            if (!v) {
              this.form.dutyParagraph.error = '税务号必填';
              return false;
            }
            this.form.dutyParagraph.error = '';
            return true;
          }
        },
        openBank: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'openBank',
          fieldName: '开户银行',
          validate: v => {
            if (!v) {
              this.form.openBank.error = '开户银行必填';
              return false;
            }
            this.form.openBank.error = '';
            return true;
          }
        },
        bankAccount: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'bankAccount',
          fieldName: '开户账号',
          validate: v => {
            if (!v) {
              this.form.bankAccount.error = '开户账号必填';
              return false;
            }
            this.form.bankAccount.error = '';
            return true;
          }
        },
        address: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'address',
          fieldName: '注册地址',
          validate: v => {
            if (!v) {
              this.form.address.error = '注册地址必填';
              return false;
            }
            this.form.address.error = '';
            return true;
          }
        },
        telPhone: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'telPhone',
          fieldName: '固定电话',
          validate: v => {
            if (!v) {
              this.form.telPhone.error = '固定电话必填';
              return false;
            }
            this.form.telPhone.error = '';
            return true;
          }
        }
      },
      requestInvoiceVisible: false,
      requestForm: {
        payRecordId: {
          require: true,
          error: false,
          value: '',
          fieldCode: 'payRecordId',
          fieldType: 'Select',
          fieldName: '开票订单',
          valueList: [],
          validate: v => {
            if (!v) {
              this.requestForm.payRecordId.error = '开票订单';
              return false;
            }
            this.requestForm.payRecordId.error = '';
            return true;
          }
        },
        invoiceType: {
          require: true,
          error: false,
          value: '',
          fieldCode: 'invoiceType',
          fieldType: 'Select',
          fieldName: '开票类型',
          valueList: [
            {
              value:"专票",
              key:"2"
            },
            {
              value:"普票",
              key:"1"
            }            
          ],
          validate: v => {
            if (!v) {
              this.requestForm.invoiceType.error = '开票类型必选';
              return false;
            }
            this.requestForm.invoiceType.error = '';
            return true;
          }
        },
        remarks: {
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'remarks',
          fieldName: '发票备注',
          validate: v => {           
            return true;
          }
        },       
        addressee: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'addressee',
          fieldName: '收件人',
          validate: v => {
            if (!v) {
              this.requestForm.addressee.error = '收件人必填';
              return false;
            }
            this.requestForm.addressee.error = '';
            return true;
          }
        },
        receiptPhone: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'receiptPhone',
          fieldName: '联系电话',
          validate: v => {
            if (!v) {
              this.requestForm.receiptPhone.error = '联系电话必填';
              return false;
            }
            this.requestForm.receiptPhone.error = '';
            return true;
          }
        },
        receiptAddress: {
          require: true,
          error: false,
          value: '',
          fieldType: 'Input',
          fieldCode: 'receiptAddress',
          fieldName: '详细地址',
          validate: v => {
            if (!v) {
              this.requestForm.receiptAddress.error = '详细地址必填';
              return false;
            }
            this.requestForm.receiptAddress.error = '';
            return true;
          }
        },
      },
      rowSelection: {
        hasSelectAll: false,
        selectedRows: [],
        onChange: (selectedRows) => {
          this.rowSelection.selectedRows = selectedRows;
        },
      }
    }
  },
  components: {
    Table,
    Pagination,
    ConfigInvoice,
    Modal,
    RequestInvoiceModal
  },
  mounted() {
    this.init();
    this.initInvoiceBuyerInfo();
    this.initTodoPayRecordList();
    
  },
  methods: {
    init() {
      this.getData();
    },
    getData() {
      const params = {
        current: this.currentPage,
        pageSize: this.pageSize,
        searchName:this.searchName
      };      
      getInvoiceApplyList(params).then((res) => {
        this.total = res.totalResult;
        this.rowsData = (res.list || []).map((item) => {
          // item._actStartDate = moment(item.actStartDate * 1000).format(
          //   "YYYY-MM-DD"
          // );
          // item._actEndDate = moment(item.actEndDate * 1000).format(
          //   "YYYY-MM-DD"
          // );
          // item._participateProgress = progressMap[item.participateProgress]
          //   ? progressMap[item.participateProgress]
          //   : "-";
          return item;
        });
      });
    },
    searchData() {
			this.pageChange(1);
		},
    pageChange(page) {
      this.currentPage = page;
      this.getData();
    },
    openInvoiceTitle() {
   
      // if(res && res.buyerName){
      //   Object.values(this.form).map(item => {
      //     item.value = '';
      //     item.error = false;
      //   })
      // }
      this.configInvoiceVisible = true;
    },
    onConfigInvoiceModalClose() {
      this.configInvoiceVisible = false;
    },
    onConfigInvoiceConfirm(param) {   
      configInvoiceBuyerInfo({        
        buyerName:param.buyerName.value,
        dutyParagraph:param.dutyParagraph.value,
        address:param.address.value,
        telPhone:param.telPhone.value,
        openBank:param.openBank.value,
        bankAccount:param.bankAccount.value
      })
        .then(() => {  
          this.configInvoiceVisible = false;       
          this.$message({
            type: "success",
            content: "配置成功",
          });
        })
        .catch((err) => {
          this.$message({
            type: "error",
            content: err,
          });
        });
    },

    initInvoiceBuyerInfo() {   
      getInvoiceBuyerInfo({})
        .then((res) => {  
          if(res && res.buyerName){
            this.form.buyerName.value = res.buyerName ;
            this.form.dutyParagraph.value = res.dutyParagraph ;
            this.form.address.value = res.address ;
            this.form.telPhone.value = res.telPhone ;
            this.form.openBank.value = res.openBank ;
            this.form.bankAccount.value = res.bankAccount ;
          } else{
            Object.values(this.form).map(item => {
              item.value = '';
              item.error = false;
            })
          }                
        })
        .catch((err) => {
          this.$message({
            type: "error",
            content: err,
          });
        });
    },

    initTodoPayRecordList() {   
      getTodoPayRecordList({})
        .then((res) => {  
          this.requestForm.payRecordId.valueList = res.list|| [];      
          this.totalAmount = res.total||0;   
        })
        .catch((err) => {
          this.$message({
            type: "error",
            content: err,
          });
        });
    },
    
    
    toDetail() {
      this.showDetail = true;
    },

    openRequestInvoice() {
      Object.values(this.requestForm).map(item => {
        item.value = '';
        item.error = false;
      })
      this.requestInvoiceVisible = true;
    },
    onRequestInvoiceModalClose() {
      this.requestInvoiceVisible = false;
    },

    onRequestInvoiceConfirm(param) {
      
      applyInvoice({        
        payRecordId:param.payRecordId.value,
        invoiceType:param.invoiceType.value,        
        remarks:param.remarks.value,
        addressee:param.addressee.value,
        receiptAddress:param.receiptAddress.value,
        receiptPhone:param.receiptPhone.value
      }).then(() => {  
          this.requestInvoiceVisible = false;      
          this.getData();
          this.initTodoPayRecordList();
          this.$message({
            type: "success",
            content: "提交成功",
          });
        }).catch((err) => {
          this.$message({
            type: "error",
            content: err,
          });
        });      
    },

    //获取开票申请列表
    getInvoiceApplyList(){

    }
  }
}
</script>

<style lang="less" scoped>
.info-box-wrap {
  display: flex;
  height: 200px;
  background: #fff;
  margin-bottom: 20px;
  
  .info-box {
    flex: 1;
    padding: 20px;
    position: relative;

    &-title {
      font-size: 28px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #000;
      margin-bottom: 20px;
    }

    b {
      margin-left: 20px;
      display: block;
      font-size: 24px;
      font-family: DINAlternate-Bold, DINAlternate;
      font-weight: bold;
      color: #06AE63;
      margin-bottom: 20px;
    }

    .info-desc {
      margin-left: 20px;
      font-size: 14px;
      font-family: DINAlternate-Bold, DINAlternate;
      margin-bottom: 10px;
    }

    .info-btn {
      margin-left: 20px;
      width: 120px;
      height: 40px;
      line-height: 40px;
      background: #f1f3f3;
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #fff;
      background: #06ae63;
      text-align: center;
      cursor: pointer;
    }
  }

  .invoice-box {
    &::before {
      content: '';
      position: absolute;
      left: 0;
      top: 10%;
      width: 0px;
      height: 80%;
      border-left: 2px dashed #BBBBBB;
    }

    .info-btn {
      color: #06AE63;
      border: 1px solid #06AE63;
      background: #fff;
    }
  }
}
.content-tips-box {
  padding: 20px;
  background: #ffffff;
  margin-bottom: 20px;
  font-size: 14px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #787878;
  line-height: 24px;
}
.content-header {
  padding: 20px;
  border-bottom: 1px solid #eeeeee;
  font-size: 16px;
  font-family: PingFangSC-Regular, PingFang SC;
  font-weight: 400;
  color: #787878;
  background: #ffffff;
  margin-bottom: 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;

  b {
    font-size: 20px;
    font-weight: 500;
    color: #131415;
    margin-right: 10px;
  }
}
.search-box {
  height: 31px;
  display: flex;

  input {
    width: 243px;
    height: 31px;
    background: #f1f3f3;
    border: none;
    padding: 6px 15px;
    box-sizing: border-box;
  }

  .search-btn {
    width: 95px;
    height: 31px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #06ae63;
    font-size: 14px;
    font-family: SourceHanSansCN-Bold, SourceHanSansCN;
    font-weight: bold;
    color: #ffffff;
    cursor: pointer;
  }
}
.search-table {
  padding-top: 12px;
  min-height: 438px;
  background: #ffffff;
  padding-bottom: 30px;
}
.table-wrap {
  margin-bottom: 30px;
}
</style>